/**
 * Category tabs for the shared ops notification inbox.
 */

import React from "react";
import { Box, Tab, Tabs, Chip } from "@mui/material";
import { INBOX_TABS, CATEGORY_ACCENT } from "../utils/taxonomy.js";
import { getCategoryIconComponent } from "../utils/icons.js";

const NotificationCategoryTabs = ({ value, onChange, counts = {}, compact = false }) => {
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
        borderRadius: "8px 8px 0 0",
        px: compact ? 0.5 : 1,
      }}
    >
      <Tabs
        value={value || "all"}
        onChange={(_e, next) => onChange(next)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        textColor="primary"
        indicatorColor="primary"
        sx={{
          minHeight: compact ? 44 : 52,
          "& .MuiTab-root": {
            minHeight: compact ? 44 : 52,
            textTransform: "none",
            fontWeight: 600,
            px: compact ? 1 : 2,
            minWidth: "auto",
          },
        }}
      >
        {INBOX_TABS.map((tab) => {
          const Icon = getCategoryIconComponent(tab.id);
          const count = counts[tab.id] ?? 0;
          const accent = CATEGORY_ACCENT[tab.id] || CATEGORY_ACCENT.all;
          return (
            <Tab
              key={tab.id}
              value={tab.id}
              icon={<Icon sx={{ fontSize: compact ? 16 : 18 }} />}
              iconPosition="start"
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: compact ? 0.5 : 1 }}>
                  <Box component="span" sx={{ fontSize: compact ? 13 : "inherit", whiteSpace: "nowrap" }}>
                    {tab.label}
                  </Box>
                  <Chip
                    size="small"
                    label={Number(count).toLocaleString()}
                    sx={{
                      height: compact ? 18 : 22,
                      fontSize: compact ? 11 : "inherit",
                      fontWeight: 600,
                      bgcolor: value === tab.id ? `${accent}22` : "action.hover",
                      color: value === tab.id ? accent : "text.secondary",
                      "& .MuiChip-label": { px: compact ? 0.75 : 1 },
                    }}
                  />
                </Box>
              }
            />
          );
        })}
      </Tabs>
    </Box>
  );
};

export default NotificationCategoryTabs;
